module.exports = "<!--<app-client></app-client>\n________________________________\n\n<app-admin-edit-product></app-admin-edit-product>-->\n\n<a routerLink=\"admin-manage-products\">Liste Produits</a>\n<a routerLink=\"admin-login\">Login</a>\n<a routerLink=\"app-client-list-products\">Liste produits pour clients</a>\n\n<div style=\"float:right\">\n    <button value=\"out\" (click)=\"logout()\"></button>\n</div>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1